function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.75 3.02321C18.1755 3.02321 17.613 3.24596 17.1795 3.67946L9.75 11.0857L9.58575 11.25L9.53925 11.4847L9.02325 14.1097L8.78925 15.2107L9.891 14.9767L12.516 14.4607L12.75 14.4142L12.9142 14.25L20.3205 6.82046C20.6309 6.50926 20.8422 6.11312 20.9278 5.68199C21.0134 5.25086 20.9695 4.80403 20.8015 4.39784C20.6336 3.99165 20.3491 3.64428 19.984 3.39951C19.6189 3.15475 19.1895 3.02355 18.75 3.02246V3.02321ZM18.75 4.47671C18.9255 4.47671 19.0987 4.56671 19.266 4.73396C19.5997 5.06846 19.5997 5.43146 19.266 5.76521L12 13.032L10.7107 13.29L10.9687 12.0007L18.2347 4.73471C18.4012 4.56821 18.5745 4.47746 18.75 4.47746V4.47671ZM3 5.99996V21H18V11.109L16.5 12.609V19.5H4.5V7.49996H11.391L12.891 5.99996H3Z",
  fill: "#4D4D4D"
});

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.372494ee.svg";
export { ForwardRef as ReactComponent };